export const hasObject = (dataList) => {
  return dataList?.length > 0 ? true : false
}
